import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import PlaceHolder from '../common/PlaceHolder';
import DiscussionGroup from './DiscussionGroup';
const DiscussionGroupWidget = ({ topicID, editData, }) => {
    const store = useStore();
    const isEmpty = () => (!topicID);
    if (editData && isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Discussion Group" }));
    }
    if (!topicID) {
        return null;
    }
    const topic = store.getOrLoad('discussionTopic', topicID);
    return (_jsx(DiscussionGroup, { topic: topic }));
};
DiscussionGroupWidget.meta = {
    group: 'portal',
    name: 'Discussion Group',
    description: 'Discussion Group with posts on selected topic.',
    props: [
        {
            key: 'topicID',
            name: 'Topic',
            type: 'discussionTopic',
            description: 'Topic to display posts for.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'DiscussionGroupWidget',
        props: {
            layout: {
                padding: {
                    top: 8,
                    left: 8,
                    right: 8,
                    bottom: 8,
                },
            },
        },
    },
};
export default observer(DiscussionGroupWidget);
//# sourceMappingURL=DiscussionGroupWidget.js.map